import { execOnLoad } from '@general/helpers';
import Swiper from 'swiper';
import { EffectFade, Navigation, Scrollbar } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import { openMinicart } from '@components/minicart';
import { throttle } from 'lodash';
import { addItemToCart } from '@services/cart';
import { closeModal, openModal } from '@components/modals';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (context) => {
  const baseClass = 'product-tile__container';
  const initializedClass = `${baseClass}--initialized`;
  const snippetContainer = context.classList.contains(baseClass)
    ? context
    : context.closest(`.${baseClass}`);
  if (
    !snippetContainer ||
    snippetContainer.classList.contains(initializedClass)
  )
    return;

  snippetContainer
    .querySelectorAll('.product-tile__meta .product-tile__colors > a')
    .forEach((colorSwatch) => {
      const url = new URL(colorSwatch.href);
      const params = url.search
        .replace('?', '')
        .split('&')
        .filter((arg) => !!arg);
      params.push('view=tile');
      url.search = `?${params.join('&')}`;

      colorSwatch.addEventListener('click', (e) => {
        e.preventDefault();
        if (
          colorSwatch.classList.contains(
            'product-tile__colors-variant--current',
          )
        )
          return;
        fetch(url.href)
          .then((res) => res.text())
          .then((data) => {
            const newTileDom = new DOMParser().parseFromString(
              data,
              'text/html',
            );
            const newContainer = newTileDom.querySelector(`.${baseClass}`);
            snippetContainer.classList.remove(initializedClass);
            snippetContainer.innerHTML = newContainer.innerHTML;
            window.dAgency.initProductTile(snippetContainer);
            if (typeof window?.dAgency?.initFitSize === 'function')
              snippetContainer
                .querySelectorAll('.fit-size__container')
                .forEach((fitSizeWrapper) =>
                  window.dAgency.initFitSize(fitSizeWrapper),
                );
          });
      });
    });

  const initContents = (
    container,
    gallerySelector,
    errorSelector,
    optionsSelector,
    submitSelector,
  ) => {
    const gallery = container.querySelector(gallerySelector);
    const slides = gallery.querySelectorAll('.swiper-slide');
    if (gallery && slides.length > 1) {
      gallery.querySelectorAll('[data-link]').forEach((link) =>
        link.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = link.dataset.link;
        }),
      );

      var pagination = gallery.querySelector(
        '.product-tile__quick-add .product-tile__gallery-pagination',
      );
      if (!pagination)
        pagination = gallery.parentElement.querySelector(
          '.product-tile__gallery-pagination',
        );
      var prevEl = gallery.querySelector('.product-tile__gallery-arrow--left');
      if (!prevEl)
        prevEl = gallery.parentElement.querySelector(
          '.product-tile__gallery-arrow--left',
        );
      var nextEl = gallery.querySelector('.product-tile__gallery-arrow--right');
      if (!nextEl)
        nextEl = gallery.parentElement.querySelector(
          '.product-tile__gallery-arrow--right',
        );
      new Swiper(gallery, {
        modules: [EffectFade, Navigation, Scrollbar],
        loop: true,
        crossFade: true,
        effect: 'fade',
        navigation: {
          prevEl,
          nextEl,
        },
        scrollbar: {
          enabled: true,
          el: pagination,
        },
      });
    }

    const errorWrapper = container.querySelector(errorSelector);
    var errorTimeout;
    const optionsWrapper = container.querySelector(optionsSelector);
    if (optionsWrapper) {
      const leftArrow = optionsWrapper.querySelector(
        '.product-tile__quick-add-option-values-arrow--left',
      );
      const rightArrow = optionsWrapper.querySelector(
        '.product-tile__quick-add-option-values-arrow--right',
      );
      if (leftArrow && rightArrow) {
        const throttleScroll = throttle(() => {
          if (optionsWrapper.scrollLeft === 0) {
            leftArrow.classList.remove('active');
          } else {
            leftArrow.classList.add('active');
          }

          if (
            optionsWrapper.scrollLeft + optionsWrapper.clientWidth ===
            optionsWrapper.scrollWidth
          ) {
            rightArrow.classList.remove('active');
          } else {
            rightArrow.classList.add('active');
          }
        }, 20);
        throttleScroll();
        optionsWrapper.addEventListener('scroll', throttleScroll);
        ['resize', 'orientationchange'].forEach((evt) =>
          window.addEventListener(evt, throttleScroll),
        );
        document.addEventListener('gridChange', throttleScroll);

        leftArrow.addEventListener('click', () =>
          optionsWrapper.scrollBy({ left: -24, behavior: 'smooth' }),
        );
        rightArrow.addEventListener('click', () =>
          optionsWrapper.scrollBy({ left: 24, behavior: 'smooth' }),
        );
      }

      const submit = container.querySelector(submitSelector);

      if (submit) {
        const mainWrapper = submit.closest('.product-tile__quick-add-wrapper');
        const sizeBtns = optionsWrapper.querySelectorAll('[data-variant-id]');
        sizeBtns.forEach((sizeBtn) => {
          const id = sizeBtn.dataset.variantId;
          if (!id) return;
          sizeBtn.addEventListener('click', () => {
            sizeBtns.forEach((btn) => btn.removeAttribute('selected'));
            sizeBtn.setAttribute('selected', '');
            submit.dataset.variantId = id;
            submit.removeAttribute('disabled');
            mainWrapper.style.transform = `translateY(-${submit.clientHeight + 10}px)`;
            mainWrapper.classList.add('active');
            if (errorWrapper) {
              clearTimeout(errorTimeout);
              errorWrapper.innerText = '';
            }
          });
        });

        const quickViewModal = submit.closest(
          '.product-tile__quick-view-modal',
        );
        submit.addEventListener('click', () => {
          const id = submit?.dataset?.variantId;
          if (!id) return;

          addItemToCart({
            id,
            quantity: 1,
            callbacks: {
              beforeFetch: () => container.classList.add('loading'),
              afterFetch: () => {
                container.classList.remove('loading');
                closeModal(quickViewModal);
                openMinicart(true);
                submit.dataset.variantId = '';
                submit.setAttribute('disabled', '');
                mainWrapper.style.transform = '';
                mainWrapper.classList.remove('active');
              },
              errorCallback: (error) => {
                container.classList.remove('loading');
                if (errorWrapper && error?.data?.message) {
                  errorWrapper.innerText = error.data.message;
                  errorTimeout = setTimeout(() => {
                    errorWrapper.innerText = '';
                  }, 5000);
                }
              },
            },
          });
        });
      }
    }
  };
  initContents(
    snippetContainer,
    '.product-tile__container > .product-tile__gallery',
    '.product-tile__gallery > .product-tile__quick-add .product-tile__quick-add-error',
    '.product-tile__gallery > .product-tile__quick-add .product-tile__quick-add-option-values',
    '.product-tile__gallery > .product-tile__quick-add .product-tile__quick-add-submit .btn',
  );

  const quickViewOpen = snippetContainer.querySelector(
    '.product-tile__quick-view-opener',
  );
  const quickViewContent = snippetContainer.querySelector(
    '.product-tile__quick-view-content',
  );
  const modal = document.querySelector('.product-tile__quick-view-modal');
  if (quickViewOpen && quickViewContent && modal) {
    const modalContent = modal.querySelector('.modal__body');
    modalContent.classList.add('product-quick-buy');

    const initTileModal = (quickViewContent, callOpenModal = true) => {
      modalContent.innerHTML = quickViewContent.innerHTML;
      initContents(
        modal,
        '.product-tile__gallery',
        '.product-tile__quick-add-error',
        '.product-tile__quick-add-option-values',
        '.product-tile__quick-add-submit .btn',
      );
      if (typeof window?.dAgency?.initFitSize === 'function') {
        modalContent
          .querySelectorAll('.fit-size__container')
          .forEach((fitSizeWrapper) => {
            fitSizeWrapper.classList.remove('fit-size__container--initialized');
            window.dAgency.initFitSize(fitSizeWrapper);
          });
      }
      if (callOpenModal) openModal(modal);

      modalContent
        .querySelectorAll('.product-tile__colors > a')
        .forEach((colorSwatch) => {
          const url = new URL(colorSwatch.href);
          const params = url.search
            .replace('?', '')
            .split('&')
            .filter((arg) => !!arg);
          params.push('view=tile');
          url.search = `?${params.join('&')}`;

          colorSwatch.addEventListener('click', (e) => {
            e.preventDefault();
            if (
              colorSwatch.classList.contains(
                'product-tile__colors-variant--current',
              )
            )
              return;

            fetch(url.href)
              .then((res) => res.text())
              .then((data) => {
                const newTileDom = new DOMParser().parseFromString(
                  data,
                  'text/html',
                );
                const newContainer = newTileDom.querySelector(`.${baseClass}`);
                snippetContainer.classList.remove(initializedClass);
                snippetContainer.innerHTML = newContainer.innerHTML;
                window.dAgency.initProductTile(snippetContainer);
                if (typeof window?.dAgency?.initFitSize === 'function')
                  snippetContainer
                    .querySelectorAll('.fit-size__container')
                    .forEach((fitSizeWrapper) =>
                      window.dAgency.initFitSize(fitSizeWrapper),
                    );
                const newQuickViewContent = newContainer.querySelector(
                  '.product-tile__quick-view-content',
                );
                initTileModal(newQuickViewContent, false);
              });
          });
        });
    };

    quickViewOpen.addEventListener('click', () => {
      initTileModal(quickViewContent);
    });
  }

  // NOTE: Temporary removed wishlist feature
  // const wishlistButton = snippetContainer.querySelector('[data-wishlist-btn]');
  // if (wishlistButton) {
  //   const toggleLoading = throttle(() => {
  //     wishlistButton.classList.toggle('loading');
  //   }, 500);
  //   wishlistButton.addEventListener('click', async (e) => {
  //     e.preventDefault();
  //     toggleLoading();
  //     const variantID = wishlistButton?.dataset?.wishlistVariantId;
  //     const masterID = wishlistButton?.dataset?.wishlistProductId;
  //     const productURL = wishlistButton?.dataset?.wishlistProductUrl;
  //     const price = wishlistButton?.dataset?.wishlistPrice;
  //     const compareAtPrice = wishlistButton?.dataset?.wishlistCompareAtPrice;

  //     if (wishlistButton?.dataset?.wishlistStatus === 'active') {
  //       await deleteFromWishlist({ variantID, masterID, productURL });
  //       wishlistButton.dataset.wishlistStatus = 'inactive';
  //     } else {
  //       await addToWishlist({
  //         variantID,
  //         masterID,
  //         productURL,
  //         compareAtPrice,
  //         price,
  //       });
  //       wishlistButton.dataset.wishlistStatus = 'active';
  //     }
  //     toggleLoading();
  //   });
  // }

  snippetContainer.classList.add(initializedClass);
};

execOnLoad(window.dAgency.initProductTile, '.product-tile__container');
